import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolAddMeritComponent } from "./school-add-merit/school-add-merit.component";
import { SchoolEditMeritComponent } from "./school-edit-merit/school-edit-merit.component";
import { DataService_PBISSetup } from "./shared/data.service";

@Component({
	selector: "app-pbissetup",
	templateUrl: "./pbissetup.component.html",
	styleUrls: ["./pbissetup.component.css"],
})
export class PBISSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private PBISSetupService: DataService_PBISSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	School: any;
	lstSchool: any = [];

	ToggleText: any = "Deactivate Merit";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedMerit: any;
	lstMerit: any = [];

	//Filter lists
	lstIsDemeritDesc: any = [];
	lstQuickMerit: any = [];
	lstUsedByDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "MeritDesc", header: "Description" },
		{ field: "MeritCD", header: "Code" },
		{ field: "IsDemeritDesc", header: "Merit/Demerit" },
		{ field: "MeritValue", header: "Value" },
		{ field: "MeritValueMin", header: "Minimum Value" },
		{ field: "MeritValueMax", header: "Maximum Value" },
		{ field: "QuickMerit", header: "Quick Merit" },
		{ field: "UsedByDesc", header: "Used By" },
		{ field: "ActiveDesc", header: "Active" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchools() {
		this.loading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.School = this.lstSchool[0];

				this.loadMerit();
			},
			(error) => {}
		);
	}

	loadMerit() {
		this.onRowUnselect(null);

		this.loading = true;

		var result = this.PBISSetupService.LoadMerits(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstMerit = response;

				for (var i = 0; i < this.lstMerit.length; i++) {
					var next = this.lstMerit[i];

					next.IsDemeritDesc = next.IsDemerit == 1 ? "Demerit" : "Merit";
					next.UsedByDesc = next.SchoolID > 0 ? "This School Only" : "District";
					next.ActiveDesc = next.Active == 1 ? "Yes" : "No";
				}

				//Load Data Filter Lists
				this.lstIsDemeritDesc = Array.from(new Set(this.lstMerit.map((item: any) => item.IsDemeritDesc))).sort();
				this.lstQuickMerit = Array.from(new Set(this.lstMerit.map((item: any) => item.QuickMerit))).sort();
				this.lstUsedByDesc = Array.from(new Set(this.lstMerit.map((item: any) => item.UsedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstMerit.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadMerit();
	}

	//Custom Button Methods
	onAddMerit() {
		this.errorMessage = "";

		// var sName: any = "";
		// for(var i = 0; i < this.lstSchool.length; i++){
		//   var next = this.lstSchool[i];

		//   if(next.SchoolID == this.SchoolID){
		//     sName = next.SchoolName;
		//     break;
		//   }
		// }

		var ref = this.dialogService.open(SchoolAddMeritComponent, {
			header: "Add Merit",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.School.SchoolID,
				SchoolName: this.School.SchoolName,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadMerit();
			}
		});
	}

	onEditMerit() {
		this.errorMessage = "";

		if (this.SelectedMerit == undefined) {
			this.errorMessage = "Select a merit or demerit to edit";
			return;
		}

		var ref = this.dialogService.open(SchoolEditMeritComponent, {
			header: "Edit Merit",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedMerit: this.SelectedMerit,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadMerit();
			}
		});
	}

	onToggleMerit() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedMerit == null) {
			this.errorMessage = "Select a merit to toggle";
			return;
		}

		//Call SP
		var changeTo = this.SelectedMerit.Active == 1 ? 0 : 1;

		var result = this.PBISSetupService.ToggleMerit(this.SelectedMerit.MeritID, changeTo);
		result.subscribe(
			(response) => {
				this.onRowUnselect(null);

				if (response) {
					this.loadMerit();
				} else {
					var FailMsg = "Could not ";
					if (changeTo == 1) {
						FailMsg += "activate the merit";
					} else {
						FailMsg += "deactivate the merit";
					}

					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: FailMsg,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		this.loadMerit();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedMerit = val.data;

		this.ToggleText = "Deactivate Merit";
		if (this.SelectedMerit.Active == 0) {
			this.ToggleText = "Activate Merit";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedMerit = null;

		this.ToggleText = "Deactivate Merit";
	}
	onRowDblClick(Merit) {
		this.errorMessage = "";

		this.SelectedMerit = Merit;
		this.onEditMerit();
	}
	////////////////////////////////////////////
}
